import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'assess-episode-chip',
  templateUrl: './episode-chip.component.html',
  styleUrls: ['./episode-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EpisodeChipComponent {
  @Input() index?: number;
}
